export default __webpack_public_path__ + "static/media/n2a.36778507.jpg";